import {
  Switch,
  Route,
  useRouteMatch
} from "react-router-dom";
import { useStyles } from "./styles";

import { GroupsListView } from "./GroupsListView";
import Header from "./ui/Header";
import { BY_ID, SETTINGS } from "../../const/URL.const";
import { GroupSettingView } from "./GroupSettingView"
import { useReducer } from "react";
import { groupSettingsReducer, initialState } from "./state";




export function GroupManagementContainer() {
  const { path } = useRouteMatch();
  const classes = useStyles();
  const [ { activeTab, groups, group}, dispatch] = useReducer(groupSettingsReducer, initialState );
  
  return (
    <div className={classes.root}>
      <Header title= {group?.name_public}/>
      <div className={classes.container}>
        <Switch>
          <Route path={`${path}${SETTINGS}${BY_ID}`}>
            <GroupSettingView activeTab={activeTab} dispatch={dispatch}/>
          </Route>
          <Route path={path}>
            <GroupsListView dispatch={dispatch}  groups={groups} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};
